import * as types from "./actionTypes"

export const changeSection = (name) => ({
  type: types.CHANGE_SECTION,
  section: name,
})

const content = { changeSection }
export default content
